/*----------------------
   ANNOUNCEMENT BAR
---------------------- */
AnnouncementBar = {
    init: function () {
        var $bar = $(".announcement-bar");
        var $messages = $bar.find(".announcement-bar__message");

        function height() {
            var h = $bar.innerHeight() + .5;
            $bar.css("margin-top", -h);
        }
        height();
        $(window).on("resize", function () {
            height();
        });
        setTimeout(function () {
            $bar.addClass("active");
        }, 500);

        // Rotation between messages
        if ($messages.length > 1) {
            var speed = (parseInt($bar.data("rotation-speed")) || 4) * 1000;
            var current = 0;
            setInterval(function () {
                $messages.eq(current).removeClass("announcement-bar__message--active");
                current = (current + 1) % $messages.length;
                $messages.eq(current).addClass("announcement-bar__message--active");
            }, speed);
        }
    }
};

$(document).ready(function () {
    AnnouncementBar.init();
});
$(document).on('shopify:section:load', function (event) {
    AnnouncementBar.init();
});
